module.exports = __webpack_public_path__ + "img/icon-38.7ec7c95f.jpg";